var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "max-width": "1000",
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex flex-wrap align-center primary--text font-weight-bold pa-8"
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-wrap align-center justify-space-around",
    attrs: {
      "color": "transparent",
      "width": "100%"
    }
  }, [_c('headshot-circle', {
    attrs: {
      "headshotData": _vm.members[0],
      "size": "sm"
    }
  }), _c('headshot-circle', {
    attrs: {
      "headshotData": _vm.members[1],
      "size": "sm"
    }
  })], 1), _c('v-sheet', {
    staticClass: "d-flex flex-wrap align-center justify-space-around",
    attrs: {
      "color": "transparent",
      "width": "100%"
    }
  }, [_c('headshot-circle', {
    attrs: {
      "headshotData": _vm.members[2],
      "size": "sm"
    }
  }), _c('headshot-circle', {
    attrs: {
      "headshotData": _vm.members[3],
      "size": "sm"
    }
  }), _c('headshot-circle', {
    attrs: {
      "headshotData": _vm.members[4],
      "size": "sm"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }